import { SORT_TYPE_NONE } from '../constants/sorts'

export const createSort = (sort) => {
  let query = ''

  if (sort.type !== SORT_TYPE_NONE) {
    query += `${sort.field},${sort.type}`
  }

  return query
}



// WEBPACK FOOTER //
// ./src/components/nexum/utils/queryParam.js